import * as React from 'react';
import * as ReactDOM from 'react-dom';
import styled from 'styled-components';
// import { dialogSize } from '@/service/jsbridge';
import { searchObj } from '@/utils/constants';
import { setBaseFontSize } from '@/utils/rem';

const { useEffect, useRef, useState } = React;
const app_env = searchObj['os_type'] === '0' || searchObj['os_type'] === '1';

const ToastMask = styled.div`
  position: absolute;
  z-index: 999999999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const MobileWrapper = styled.div`
  background: rgba(0, 0, 0, 0.8);
  border-radius: 6px;
  padding: 0.16em;
  color: #ffffff;
  display: flex;
`;
const WebWrapper = styled.div`
  position: absolute;
  width: 132px;
  height: 48px;
  font-size: 14px !important;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
  color: #222222;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const MobileText = styled.span`
  font-size: 0.17em !important;
`;

interface IFuncCb {
  (): void;
}

export default class Toast {
  static renderToast(App: any, time: number = 1000, cb?: IFuncCb) {
    const root = document.body;
    const container = document.createElement('div');
    root.appendChild(container);
    setBaseFontSize(container);
    ReactDOM.render(App, container);

    setTimeout(() => {
      ReactDOM.unmountComponentAtNode(container);
      root.removeChild(container);
      if (cb) {
        cb();
      }
    }, time);
  }

  static mobileAlert(text: string, cb?: IFuncCb) {
    const MobileToast = () => {
      const [show, setShow] = useState(!app_env);
      const divRef = useRef<HTMLDivElement>(null);
      useEffect(() => {
        // if (divRef.current) {
        //   dialogSize(divRef.current);
        // }
        const timeout = setTimeout(() => {
          setShow(true);
        }, 300);
        return () => {
          clearTimeout(timeout);
        };
      }, []);
      return (
        <ToastMask>
          <MobileWrapper
            style={{ visibility: show ? 'visible' : 'hidden' }}
            ref={divRef}
          >
            <MobileText>{text}</MobileText>
          </MobileWrapper>
        </ToastMask>
      );
    };
    Toast.renderToast(<MobileToast />, 900, cb);
  }

  static webAlert(text: string, cb?: IFuncCb) {
    const WebToast = () => {
      return (
        <ToastMask>
          <WebWrapper>
            <svg width="16" height="16" x="0px" y="0px" viewBox="0 0 16 16">
              <path
                fill="#00AA54"
                d="M0,8c0-4.4,3.6-8,8-8s8,3.6,8,8s-3.6,8-8,8S0,12.4,0,8z M7,9.4L5.6,7.9c-0.3-0.3-0.8-0.3-1.1,0
              c-0.3,0.3-0.3,0.8,0,1.1l2,2c0.3,0.3,0.8,0.3,1.1,0l4.5-4.5c0.3-0.3,0.3-0.8,0-1.1s-0.8-0.3-1.1,0L7,9.4z"
              />
            </svg>
            <span style={{ marginLeft: 12 }}>{text}</span>
          </WebWrapper>
        </ToastMask>
      );
    };
    Toast.renderToast(<WebToast />, 1000, cb);
  }
}
